<template>
  <!-- VS Gaming prize lead: "inline" (amount + unit) or "pill" (amount + filled unit pill). -->
  <p class="prize" :class="[`prize--${prize.style}`, { 'prize--compact': compact }]">
    <span class="prize__amount">{{ prize.amount }}</span>
    <span class="prize__unit">{{ prize.unit }}</span>
  </p>
</template>

<script setup>
defineProps({
  prize: { type: Object, required: true },
  // Typed-number steps: smaller, so field + PIN + CONFIRM + strip still fit a 360x640 screen.
  compact: { type: Boolean, default: false }
})
</script>

<style scoped>
.prize {
  display: flex;
  font-family: var(--font-display);
  color: var(--prize-color);
}

.prize--inline {
  align-items: baseline;
  gap: 10px;
}

.prize--inline .prize__amount {
  font-size: 58px;
  font-weight: 700;
  line-height: .95;
  letter-spacing: -.01em;
}

.prize--inline .prize__unit {
  font-size: 24px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .04em;
}

.prize--pill {
  align-items: center;
  gap: 12px;
}

.prize--pill .prize__amount {
  font-size: 78px;
  font-weight: 700;
  line-height: .9;
}

.prize--pill .prize__unit {
  padding: 8px 20px;
  border-radius: 9999px;
  background: var(--prize-color);
  color: var(--color-bg);
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: .06em;
}

.prize--compact.prize--inline .prize__amount {
  font-size: 44px;
}

.prize--compact.prize--inline .prize__unit {
  font-size: 20px;
}

.prize--compact.prize--pill .prize__amount {
  font-size: 56px;
}

.prize--compact.prize--pill .prize__unit {
  padding: 6px 16px;
  font-size: 16px;
}
</style>
